<div class="agpr-compositionReport-center">
    <div class="agpr-compositionReport-tabs-container">
        <agpr-tabs
            class="agpr-compositionReport-tabs"
            [selectedTabIndex]="selectedTabIndex"
            (selectedTabIndexChange)="changeTab($event)"
        >
            <agpr-tab
                [heading]="'Discover.compositionReport.type.inbox'"
                [id]="'compositionReport.inboxTab'"
            >
            </agpr-tab>
            <agpr-tab
                [heading]="'Discover.compositionReport.type.html'"
                [id]="'compositionReport.htmlTab'"
            >
            </agpr-tab>
            <agpr-tab
                [heading]="'Discover.compositionReport.type.plaintext'"
                [id]="'compositionReport.plainTextTab'"
            >
            </agpr-tab>
        </agpr-tabs>
    </div>
    <agpr-scroll-panel class="agpr-compositionReport-scrollPanel">
        <div *ngIf="selectedTabIndex === 0">
            <agpr-shadow-dom-container [customHtml]="_bodyHtml"></agpr-shadow-dom-container>
        </div>
        <div *ngIf="selectedTabIndex === 1 && bodyHtmlCode">
            <agpr-accessible-code-mirror
                [value]="bodyHtmlCode"
                [config]="cmConfig"
                codeMirrorStyleClass="agpr-compositionReport-codemirror"
            ></agpr-accessible-code-mirror>
        </div>
        <pre
            class="agpr-compositionReport-plainText"
            *ngIf="selectedTabIndex === 2 && bodyPlainText"
            [innerHTML]="bodyPlainText + footerPlainText"
        ></pre>

        @if(isRSSFeed) {
            <agpr-message [severity]="messageSeverities.noContent" class="noContent">
                <div class="noContent-maintext">{{ 'Discover.distributionReport.noContent' | localize}}</div>
                {{'Briefings.sentReport.rssFeed.cannotBeDisplayed' | localize}}
            </agpr-message>
        } @else {
            @if(!_bodyHtml) {
                @switch(status) {
                    @case(statisticsResourceStatus.pending) {
                        <agpr-message [severity]="messageSeverities.noContent" class="noContent">
                            <div class="noContent-maintext">{{ 'Discover.distributionReport.noContent' | localize}}</div>
                            {{'Discover.distributionReport.pendingNotice' | localize}}
                        </agpr-message>
                    }
                    @case(statisticsResourceStatus.scheduled) {
                        <agpr-message [severity]="messageSeverities.noContent" class="noContent">
                            <div class="noContent-maintext">{{ 'Discover.distributionReport.noContent' | localize}}</div>
                            {{'Discover.distributionReport.scheduledNoContent' | localize}}
                        </agpr-message>
                    }
                    @default {
                        <agpr-message [severity]="messageSeverities.noContent" class="noContent">
                            <div class="noContent-maintext">{{ 'Discover.distributionReport.noContent' | localize}}</div>
                            {{'Discover.distributionReport.noContentNotice' | localize}}
                        </agpr-message>
                    }
                }
            }
        }
        <agpr-message
            *ngIf="status === statisticsResourceStatus.pending && !_bodyHtml && !isRSSFeed"
            [severity]="messageSeverities.noContent"
        >
            {{'Discover.distributionReport.pendingNotice' | localize}}
        </agpr-message>



    </agpr-scroll-panel>

</div>
